const timeZoneMap = [
	{
		zone: 'PST',
		value: 'America/Los_Angeles',
	},
	{
		zone: 'EST',
		value: 'America/New_York',
	},
	{
		zone: 'CST',
		value: 'America/Chicago',
	},
	{
		zone: 'MST',
		value: 'America/Denver',
	},
	{
		zone: 'MST',
		value: 'America/Phoenix',
	},
];

export const getLocalTimeFromTimeZone = (timeZoneId: string) => {
	if (timeZoneId.length === 0) {
		return {
			localDayOfWeek: '',
			localTime: '',
			localAmOrPm: '',
		};
	}
	const localTimeZone = timeZoneMap.find((timeZoneMapItem) => timeZoneMapItem.zone === timeZoneId);
	const options = {
		weekday: 'long',
		hour: '2-digit',
		minute: '2-digit',
		hour12: true,
		timeZone: localTimeZone?.value ?? 'CST',
	};
	const date = new Date();
	const time = date.toLocaleString('en-US', options as Intl.DateTimeFormatOptions);
	const [localDayOfWeek, localTime, localAmOrPm] = time.split(' ');
	return {
		localDayOfWeek,
		localTime,
		localAmOrPm,
	};
};
